import { render, staticRenderFns } from "./DentcoAlertBar.vue?vue&type=template&id=586d7de6&scoped=true"
import script from "./DentcoAlertBar.vue?vue&type=script&lang=js"
export * from "./DentcoAlertBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d7de6",
  null
  
)

export default component.exports